function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M16.269 1.077c-1.934-1.653-4.781-1.336-6.574.492l-.668.703-.703-.703C6.566-.26 3.683-.576 1.749 1.077-.466 2.975-.57 6.35 1.398 8.389l6.82 7.031c.422.457 1.16.457 1.582 0l6.82-7.03c1.97-2.04 1.864-5.415-.351-7.313z",
  fill: "#EFB9B9"
});

function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 19 16",
    fill: "none"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxOSAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggaWQ9ImhlYXJ0IiBkPSJNMTYuMjY4OCAxLjA3NjZDMTQuMzM1MiAtMC41NzU3MzkgMTEuNDg3NiAtMC4yNTkzMzMgOS42OTQ2MiAxLjU2ODc5TDkuMDI2NjUgMi4yNzE5Mkw4LjMyMzUzIDEuNTY4NzlDNi41NjU3MiAtMC4yNTkzMzMgMy42ODI5IC0wLjU3NTczOSAxLjc0OTMxIDEuMDc2NkMtMC40NjU1MzMgMi45NzUwNCAtMC41NzEwMDIgNi4zNTAwNCAxLjM5Nzc1IDguMzg5MUw4LjIxODA2IDE1LjQyMDRDOC42Mzk5NCAxNS44Nzc0IDkuMzc4MjIgMTUuODc3NCA5LjgwMDA5IDE1LjQyMDRMMTYuNjIwNCA4LjM4OTFDMTguNTg5MiA2LjM1MDA0IDE4LjQ4MzcgMi45NzUwNCAxNi4yNjg4IDEuMDc2NloiIGZpbGw9IiNFRkI5QjkiLz4KPC9zdmc+Cg==";
export { SvgHeart as ReactComponent };